import React, { useState, useEffect } from 'react'
import { useDispatch } from 'react-redux'

import Api from 'services/Api'
import BaseModal from 'components/Modals/BaseModal'
import { closeModal } from 'store/actions/modals'
import { Button } from 'components/Forms'
import { Alert } from 'ui'
import { EventSummaryList } from 'components/Schedule'
import { TrackAction } from 'services/TrackAction'
import { t } from 'translations'

const ScheduleUnpublishModal = ({ shiftIds, scheduleFilter }) => {
  const dispatch = useDispatch()

  const [events, setEvents] = useState()
  const [errorLoading, setErrorLoading] = useState(false)
  const [isSubmitting, setSubmitting] = useState(false)

  // Load events
  useEffect(() => {
    const fetchEvents = async () => {
      setEvents()
      if (!scheduleFilter && !shiftIds?.length) return setEvents([])
      const query = typeof scheduleFilter !== 'undefined' ? { ...scheduleFilter, published: true } : { shiftIds, published: true }
      const { result, success } = await Api.post('schedule/schedule/query', { ...query, returnScheduleContactEvents: true })
      if (!success) return setErrorLoading(true)
      setEvents(result)
    }
    fetchEvents()
  }, [shiftIds, scheduleFilter])

  const unpublish = async () => {
    setSubmitting(true)
    await Api.put('schedule/publish', { shiftIds: events.map(({ _id }) => _id), publish: false })
    // Track that user has published shifts
    TrackAction('PUBLISH_SHIFTS')
    dispatch(closeModal())
  }

  if (!events && !errorLoading) return <BaseModal hideButtons title="manager.schedule.PUBLISH_MODAL" isLoading />

  return (
    <BaseModal hideButtons title={`manager.schedule.UNPUBLISH`}>
      {errorLoading ? (
        <>
          <Alert variant="warning" className="mt-2">
            {t('manager.schedule.UNPUBLISH.ERROR_LOADING')}
          </Alert>{' '}
          :
          <Button text="actions.CLOSE" className="btn btn-outline-secondary mt-2" onClick={() => dispatch(closeModal())} />
        </>
      ) : (
        <div>
          <Alert variant="warning" className="my-2">
            {events.length ? (
              <div>
                <i className={`fas fa-exclamation-triangle mr-2`} />
                {t(`manager.schedule.UNPUBLISH.ALERT`)}
              </div>
            ) : null}
          </Alert>

          {/* Only show event summary if user has selected events */}
          {events.length ? (
            <div className="mb-2">
              <EventSummaryList title={`manager.schedule.PUBLISH_MODAL.EVENTS`} events={events} />
            </div>
          ) : null}

          <div className="mt-2">
            <Button className="btn btn-primary mr-2" type="submit" disabled={!events.length} isSubmitting={isSubmitting} text="SUBMIT" onClick={unpublish} />
            <Button className="btn btn-outline-secondary" onClick={() => dispatch(closeModal())}>
              {t(`actions.CLOSE`)}
            </Button>
          </div>
        </div>
      )}
    </BaseModal>
  )
}

export default ScheduleUnpublishModal
